/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { filter, some } from 'lodash';
import { SCOPES } from '@config/index';
import { useSwitchEmployers } from './useSwitchEmployers';
import { useGetPermissions } from './useGetPermissions';
import { ContractorData } from './types';
import { useAppSelector } from './redux.hooks';

export const usePermissions = () => {
  const { siteEmployers } = useSwitchEmployers();
  const { currentUser } = useAppSelector((state) => state.account);
  const { role } = currentUser;
  const isStaffingContractor = role === 'staffing_contractor';
  const isRegularContractor = role === 'regular_contractor';
  const permissions = useGetPermissions();
  const canViewStaffingContractorF30Page = siteEmployers?.some(
    (siteEmployer) => siteEmployer.config?.f30?.includes(SCOPES.canViewStaffingContractorF30Page),
  );
  const canViewRegularContractorF30Page = siteEmployers?.some(
    (siteEmployer) => siteEmployer.config?.f30?.includes(SCOPES.canViewRegularContractorF30Page)
    && !isStaffingContractor,
  );
  const canStaffingContractorAreaViewInvoicesPage = permissions.includes(
    SCOPES.canViewInvoicesPage,
  );
  const canStaffingContractorAreaViewF30Page = permissions.includes(
    SCOPES.canViewStaffingContractorF30Page,
  );
  const canRegularContractorAreaViewF30Page = permissions.includes(
    SCOPES.canViewRegularContractorF30Page,
  );
  const canStaffingContractorViewInvoicesPage = siteEmployers?.some(
    (siteEmployer) => siteEmployer.config?.invoice?.includes(SCOPES.canViewInvoicesPage),
  );
  const employersWithVehiclesJobGroups = filter(siteEmployers, (siteEmployer) => (
    siteEmployer.jobFields.includes('vehicle_groups')
  ));
  const hasVehicleGroupsJob = some(siteEmployers, (employer) => (
    employer.jobFields.includes('vehicle_groups')
  ));
  const canViewAreaSectionVehiclesPage = permissions.includes(
    SCOPES.canViewAreaSectionVehiclesPage,
  );
  const canViewAreaSectionEventListPage = permissions.includes(
    SCOPES.canViewAreaSectionEventListPage,
  );
  const canManageVehicle = permissions.includes(
    SCOPES.canManageVehicle,
  );
  const canViewAssociationsTab = permissions.includes(
    SCOPES.canViewAssociationsTab,
  );
  const hasVehicleGroupsJobContractor = (contractor: ContractorData) => (
    contractor?.jobFields?.includes('vehicle_groups')
  );
  const employersF30ConfigActivated = filter(siteEmployers, (employer) => {
    if (isStaffingContractor) {
      return employer.config?.f30?.includes(SCOPES.canViewStaffingContractorF30Page);
    }
    if (isRegularContractor) {
      return employer.config?.f30?.includes(SCOPES.canViewRegularContractorF30Page);
    }
    return true;
  });
  const employersInvoiceConfigActivated = filter(siteEmployers, (employer) => (
    employer.config?.invoice?.includes(SCOPES.canViewInvoicesPage)
  ));
  const f30Permissions = siteEmployers?.find((siteEmployer) => (
    siteEmployer.id === currentUser?.contractorId
  ));
  const canViewAddDocumentButton = permissions.includes(
    SCOPES.canViewAddDocumentButton,
  );

  const canManageMutual = permissions.includes(
    SCOPES.canManageMutual,
  );

  return {
    hasVehicleGroupsJob,
    canViewStaffingContractorF30Page,
    canViewRegularContractorF30Page,
    canStaffingContractorAreaViewInvoicesPage,
    canManageVehicle,
    employersWithVehiclesJobGroups,
    canViewAreaSectionVehiclesPage,
    hasVehicleGroupsJobContractor,
    employersF30ConfigActivated,
    employersInvoiceConfigActivated,
    canStaffingContractorViewInvoicesPage,
    canStaffingContractorAreaViewF30Page,
    canRegularContractorAreaViewF30Page,
    canViewAreaSectionEventListPage,
    canViewAssociationsTab,
    f30Permissions,
    canViewAddDocumentButton,
    canManageMutual,
  };
};
